import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { renderCustomizedLabel } from './renderCustomLabel';
import { CustomLegend } from './CustomeLegend';
import { Row } from 'reactstrap';

const data = [
  { name: 'Promoters', value: 50 },
  { name: 'Detractors', value: 20 },
  { name: 'Passives', value: 30 },
];

const COLORS = ['#00C49F', '#FF8042', '#FFBB28'];

const NPSCategoriesPieChart = () => (
  <Row>
      <CustomLegend colors={COLORS} data={data} />
      <PieChart
        width={300}
        height={300}>
        <Pie
          data={data}

          labelLine={false}
          label={renderCustomizedLabel}

          fill='#8884d8'
          dataKey='value'
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie> <Tooltip />
        {/*<Legend layout='horizontal' verticalAlign='bottom' align='bottom' />*/}
      </PieChart>

    </Row>
);

export default NPSCategoriesPieChart;